import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
export default function NotFound(props) {
  var location = useLocation();
  useEffect(function () {
    document.title = 'Not Found';
  });
  return /*#__PURE__*/React.createElement("div", null, "404 ", /*#__PURE__*/React.createElement("br", null), location.pathname, " was not found.");
}